<template>
  <div class="form-group">
    <label class="label-option">
      {{ $i18nPresenter.t("Additional fields") }}
      <span class="title-table-presentation-tooltip result-layout-tooltip">
        <b-button
          v-tooltip="$i18nPresenter.t(
            'You can collect additional info from each response such as the responder\'s name, team name, etc.'
          )"
          class="tooltip-btn"
        />
        <i class="fas fa-question-circle" />
      </span>
    </label>

    <div v-if="$store.state.slideActive.additionalFields">
      <AdditionalFieldsForm
        @updateAdditionalFields="updateAdditionalFields"
        :limitFields="4"
        type="openEnded"
      />
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import * as Sentry from '@sentry/vue'
import Socket from '@/socket'
import AdditionalFieldsForm from '@/components-v2/presentation-editor/side-right/AdditionalFieldsForm.vue'
import SlideApi from '@/api/slide'

export default {
  components: {
    AdditionalFieldsForm,
  },
  methods: {
    ...mapActions(['updateSlideActiveAction']),
    async updateAdditionalFields() {
      this.updateSlideActiveAction(this.$store.state.slideActive)
      const payload = {
        additionalFields: JSON.stringify(
          this.$store.state.slideActive.additionalFields,
        ),
        socketId: Socket.getSocketId(),
        accessCode: this.$store.state.presentation.uniqueAccessCode,
        presenting: this.$store.getters.isPresenting,
      }
      const slideId = this.$store.state.slideActive.id

      try {
        await SlideApi.updateSlideById(slideId, payload)
        const index = this.$store.state.presentation.slides.findIndex((item) => {
          return item.id === slideId
        })

        if (index !== -1) {
          this.$store.state.presentation.slides[
            index
          ].additionalFields = JSON.parse(payload.additionalFields)
        }
        return true
      } catch (error) {
        Sentry.captureException(error)
        return false
      }
    },
  },
}
</script>
